import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { muteAllMediaOnce } from './utils/media-utils';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'shellbox-web';

  constructor(
    public authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  async ngOnInit() {
    this.authService.checkAuth();
    if (isPlatformBrowser(this.platformId)) {
      muteAllMediaOnce()
    }
  }

}
